"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTabClassic = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const buttonReset_styles_1 = require("../../../../DesignSystem/styles/buttonReset.styles");
const Tab_1 = require("../../../designTokens/Tab");
const TabList_1 = require("../../../designTokens/TabList");
exports.StyledTabClassic = styled_components_1.default.button `
    ${buttonReset_styles_1.buttonReset};
    box-sizing: border-box;
    position: relative;
    padding-top: ${Tab_1.tabTokens.tabPaddingTop.getVar()};
    padding-right: ${Tab_1.tabTokens.tabPaddingRight.getVar()};
    padding-bottom: ${Tab_1.tabTokens.tabPaddingBottom.getVar()};
    padding-left: ${Tab_1.tabTokens.tabPaddingLeft.getVar()};
    border-right: ${TabList_1.tabListTokens.tabListBorderWidth.getVar()} solid
        ${TabList_1.tabListTokens.tabListBorderColor.getVar()};
    cursor: pointer;
    background-color: ${Tab_1.tabTokens.tabBackgroundColor.getVar()};

    &:hover {
        background-color: ${Tab_1.tabTokens.tabHoverBackgroundColor.getVar()};
    }

    ${({ active, isDisabled }) => active &&
    !isDisabled &&
    (0, styled_components_1.css) `
            border-left: ${Tab_1.tabTokens.tabActiveBorderLeftWidth.getVar()} solid
                ${Tab_1.tabTokens.tabActiveBorderLeftColor.getVar()};
            padding-left: calc(
                ${Tab_1.tabTokens.tabPaddingLeft.getVar()} -
                    ${Tab_1.tabTokens.tabActiveBorderLeftWidth.getVar()}
            );
            background-color: ${Tab_1.tabTokens.tabActiveBackgroundColor.getVar()};

            &:before {
                content: '';
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);

                border-top: 7px solid transparent;
                border-right: 7px solid ${Tab_1.tabTokens.tabTriangleBorderColor.getVar()};
                border-bottom: 7px solid transparent;
                border-left: 7px solid transparent;
            }

            &:after {
                content: '';
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: calc(-1 * ${TabList_1.tabListTokens.tabListBorderWidth.getVar()});
                border-top: 7px solid transparent;
                border-right: 7px solid ${Tab_1.tabTokens.tabTriangleBackgroundColor.getVar()};
                border-bottom: 7px solid transparent;
                border-left: 7px solid transparent;
            }

            &:hover {
                background-color: ${Tab_1.tabTokens.tabActiveHoverBackgroundColor.getVar()};
            }
        `}

    ${({ isDisabled }) => isDisabled &&
    (0, styled_components_1.css) `
            cursor: default;

            &,
            &:hover {
                background-color: ${Tab_1.tabTokens.tabDisabledBackgroundColor.getVar()};
            }
        `}
`;
//# sourceMappingURL=TabClassic.styles.js.map